import React from "react";

function DiscountCounter({ relative = false, number }) {
  return (
    <div
      className={`${relative ? 'relative' : 'absolute z-10'} text-[13px] ${relative ? null : 'top-3 left-3'} bg-secondary
 text-white px-4 py-1 rounded-full w-fit`}
    >
      -{number}%
    </div>
  );
}

export default DiscountCounter;
